import React from "react";
import * as S from "./styles";
import { useKOGAutoCompletePaginationControlled } from "./autoCompletePaginationControlled";
import { getDefaultMessageResultsFound } from "@/main/services/utils";

export const ID_RESULTS_FOUND_LIST_BOX_PAGINATION: string = "id-area-autocomplete-results-found";
export const ID_LOADING_LIST_BOX_PAGINATION: string = "id-area-autocomplete-loading";

const ListBoxComponentAutoCompletePagination = React.forwardRef<
	HTMLUListElement,
	React.PropsWithChildren<React.HTMLAttributes<HTMLUListElement>>
>((params, ref) => {
	const { result, options } = useKOGAutoCompletePaginationControlled();
	const results = getDefaultMessageResultsFound(options.length, result?.totalNumberOfRecords ?? 0);
	return (
		<>
			<S.AreaResultsNotFound>{results}</S.AreaResultsNotFound>
			<ul {...params} ref={ref} style={{ padding: 0, maxHeight: 300 }} />
			<S.AreaLoading id={ID_LOADING_LIST_BOX_PAGINATION} />
		</>
	);
});

export default ListBoxComponentAutoCompletePagination;
